import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { COSMETIC_EVALUATION_API } from '../cosmeticEvaluationClient';
import { IDoneUploadingDeviceImagesResponseData } from '../types';

/**
 * This is to track whether the devices images have been all uploaded.
 */
const DONE_UPLOADING_DEVICE_IMAGES_KEY = 'done-uploading-devices-images-key';

interface IUseDoneUploadingDeviceImagesOptions {
  onSuccessCallback: (
    imageResponseData: IDoneUploadingDeviceImagesResponseData
  ) => void;
  onErrorCallback: (err: IApiError) => void;
}

/**
 * This hook will call cosmetic evaluation service api and post to the backend
 * that all the images have been uploaded for the session to be ended.
 *
 * @deprecated - This is not being used at the moment. Will be removed later.
 */
export const useDoneUploadingDeviceImagesMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseDoneUploadingDeviceImagesOptions) => {
  const { error, data, isPending, mutate } = useMutation({
    mutationKey: [DONE_UPLOADING_DEVICE_IMAGES_KEY],
    networkMode: 'always',
    retry: false,
    mutationFn: COSMETIC_EVALUATION_API.doneUploadingImage,
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    data,
    error,
    isPending,
    callDoneUploadingDeviceImages: mutate,
  };
};
